import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome"
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from '@fortawesome/free-solid-svg-icons'
import {fab} from'@fortawesome/free-brands-svg-icons'

library.add(fas, fab);

export default FontAwesomeIcon